import { useContext } from "react"

import { useStore } from "zustand"

import { SignupForm } from "@/components/account/SignupForm"
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"
import { EmbedTurnstileFrameContext } from "@/embed/turnstile-frame-context"
import { store } from "@/lib/store"

export type EmbedSignupDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSuccess: (email: string) => void
  onSignInClick: () => void
}

export function EmbedSignupDialog({
  open,
  onOpenChange,
  onSuccess,
  onSignInClick,
}: EmbedSignupDialogProps) {
  const partnerId = useStore(store, (state) => state.embedPartnerId)
  const embedUserId = useStore(store, (state) => state.embedUserId)
  const turnstileFrame = useContext(EmbedTurnstileFrameContext)
  const prefillEmail = useStore(store, (state) => state.embedPrefillEmail)
  const prefillFirstName = useStore(
    store,
    (state) => state.embedPrefillFirstName,
  )
  const prefillLastName = useStore(store, (state) => state.embedPrefillLastName)

  if (!partnerId || !embedUserId) {
    return null
  }

  // Only pass `prefill` when the partner actually supplied a value, so the
  // non-embed mental model (a blank form) is preserved when nothing is set.
  const prefill =
    prefillEmail || prefillFirstName || prefillLastName
      ? {
          email: prefillEmail,
          firstName: prefillFirstName,
          lastName: prefillLastName,
        }
      : undefined

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" aria-describedby={undefined}>
        <DialogTitle className="text-2xl font-bold text-neutral-800">
          Create account
        </DialogTitle>
        <SignupForm
          onSuccess={onSuccess}
          onSignInClick={onSignInClick}
          slug={partnerId}
          embedUserId={embedUserId}
          prefill={prefill}
          turnstileFrame={turnstileFrame ?? undefined}
        />
      </DialogContent>
    </Dialog>
  )
}
